import React, { type CSSProperties, type ReactNode } from 'react';
import { Link as RouterLink } from '@tanstack/react-router';

export type AppLinkProps = {
  to: string;
  children?: ReactNode;
  className?: string;
  title?: string;
  style?: CSSProperties;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  id?: string;
  'aria-label'?: string;
  'data-nav-active'?: string;
};

/** Typed wrapper around TanStack Router Link (accepts children + className). */
const LinkWithChildren = RouterLink as React.FC<AppLinkProps>;

export const AppLink: React.FC<AppLinkProps> = (props) => <LinkWithChildren {...props} />;
